import { ThemeProvider } from 'styled-components'
import { BrowserRouter as Router } from 'react-router-dom'
import GlobalStyle from '~assets/styles/global'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import Routes from '~routes'
import '@frete.com/fuel-fonts/satoshi/fontface.css'
import 'react-loading-skeleton/dist/skeleton.css'

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Routes />
      </ThemeProvider>
    </Router>
  )
}

export default App
